import React, { useState } from "react";
import Button from "@material-ui/core/Button";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import CloseIcon from "../../assets/images/clear.svg";
import Wallet from "../../assets/images/CoinWallet.svg";
import TextField from "@material-ui/core/TextField";
import wallet from "../../assets/images/WalletB.svg";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { mapStateToProps, mapDispatchToProps } from "../../actions/addresses";
import { useStylesNewAccount } from "./style";
import { useCopyAddress } from "../../hooks/copyAddress";
import * as sdk from "boa-sdk-ts";
import { ErrorCheckUtil } from "../../utils/ErrorCheckUtil";
import { saveWalletData } from "../../utils/WalletUtils";
import { WalletMA } from "boa-sdk-ts";
import { Checkbox } from "rsuite";

const NewAccount = (props) => {
  const { t } = props;
  const classes = useStylesNewAccount();
  const [openKeyModal, setOpenKeyModal] = useState(false);
  const [openDiv, setOpenDiv] = useState(true);
  const [secretKey, setSecretKey] = useState("");
  const [secretKeyCopy, setSecretKeyCopy] = useState("");
  const [publicKeyCopy, setPublicKeyCopy] = useState("");
  const [walletName, setWalletName] = useState("");
  const [error, setError] = useState("");
  const [copyText, CopyContactAddress] = useCopyAddress();
  const [confirmCopy, setConfirmCopy] = useState(false);

  // Method use to create new account
  const createAccount = async () => {
    setError("");
    let keyPair = await sdk.KeyPair.random();
    setSecretKeyCopy(keyPair.secret.toString(false));
    setPublicKeyCopy(keyPair.address.toString());
    setOpenKeyModal(true);
  };

  // Method to show modal for public and private address
  const handleCloseKeysModal = () => {
    setOpenKeyModal(false);
  };

  const addNewAccount = () => {
    const { accounts } = WalletMA.instance();
    const key = secretKey.trim();
    let res;
    let isPublic = false;
    if (key.length === 0) {
      setError(t("Enter_seed_or_public_Mandotary"));
      return;
    } else if (key[0] === "S") {
      res = sdk.WalletValidator.isValidSecretKey(secretKey);
    } else if (key[0] === "b") {
      res = sdk.WalletValidator.isValidPublicKey(secretKey);
      isPublic = true;
    } else {
      setError(t("This_key_is_not_valid"));
      return;
    }

    if (ErrorCheckUtil.resCodeCheck(res)) {
      if (isPublic) {
        accounts.add(
          walletName ? walletName : secretKey,
          new sdk.PublicKey(secretKey)
        );
      } else {
        const sKey = new sdk.SecretKey(secretKey);
        accounts.add(
          walletName
            ? walletName
            : sdk.KeyPair.fromSeed(sKey).address.toString(),
          sKey
        );
      }
      saveWalletData();
      backToPanel();
    }
  };

  // Method to back panel page.
  const backToPanel = () => {
    props.history.push("/overview");
  };

  const copyConfirmHandler = (value, checked) => {
    setConfirmCopy(checked);
  };

  return (
    <>
      <div className="welcome-box">
        <div className="welcomeContainer align-items-center">
          {/* Welcome Section without Login */}
          {openDiv ? (
            <div className="welcomeDesc">
              <h1 className="welcomeTitle">
                {t("Welcome_to_BOSAGORA_Wallet")}
              </h1>
              <h3 className="welcomeSecText">
                {t("Secure_Easy_to_Use_Crypto_Wallet")}
              </h3>
              <img
                className="mx-auto d-block wallet-img"
                alt="wallet"
                src={wallet}
              />
            </div>
          ) : (
            <div className="welcomeDesc">
              {/* Welcome section after going to create new wallet */}
              <h1 className="welcomeTitle">{t("Welcome_to_New_Wallet")}</h1>
              <h3 className="welcomeSecText">
                {t("Follow_these_steps_to_create_a_new_wallet")}
              </h3>
              <img
                className="mx-auto d-block depo-img"
                alt="Wallet"
                src={Wallet}
              />
            </div>
          )}
          <div className="welcomeBox">
            <div className="SecretKey">
              <div className="SecretKeyForm cardBg">
                {/* Enter Secret Key or Public Key to create new wallet */}
                <h1 className="SecretTitle">
                  {t("Secret_Seed_or_Public_Key")}
                </h1>
                <div className="SecretInputCont">
                  <TextField
                    className="SecretInput"
                    id="filled-basic"
                    value={secretKey}
                    onChange={(e) => setSecretKey(e.target.value)}
                    label={t("Enter_seed_or_public_Mandotary")}
                    variant="filled"
                    autoComplete="off"
                  />
                  {/* Button to open Modal for add new account */}
                  {secretKey.length > 0 ? (
                    ""
                  ) : (
                    <Button
                      className="CreateBtn"
                      variant="contained"
                      color="primary"
                      onClick={(e) => createAccount(e)}
                    >
                      {t("Create")}
                    </Button>
                  )}
                </div>
                <span className="validText">
                  <p style={{ color: "red" }}> {error}</p>
                </span>
                <div className="EndpointBoxName">
                  <TextField
                    className="SecretInput"
                    id="filled-basic"
                    onChange={(e) => setWalletName(e.target.value)}
                    value={walletName}
                    label={t("Wallet_Name")}
                    variant="filled"
                    autoComplete="off"
                  />
                </div>
                <div className="btn_footer">
                  <button
                    className="btn btn-default NextBtn"
                    onClick={(e) => addNewAccount(e)}
                  >
                    {t("Confirm")}
                  </button>
                  <button
                    className="btn btn-default NextBtn"
                    onClick={(e) => backToPanel(e)}
                  >
                    {t("Back")}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="SendModal">
        {/* Add new account modal component */}
        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          className={classes.modal}
          open={openKeyModal}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500,
          }}
        >
          <Fade in={openKeyModal}>
            <div className={`${classes.paper} modalBg`}>
              <img
                alt="CloseIcon"
                className={
                  !confirmCopy ? "ClearModalImg hidden" : "ClearModalImg"
                }
                src={CloseIcon}
                onClick={handleCloseKeysModal}
              />
              <h2 className="modalTitle" id="transition-modal-title">
                {t("Create_Wallet")}
              </h2>
              <div className="modalInput label-color flexWrap">
                <TextField
                  label={t("Secret_Key")}
                  value={secretKeyCopy}
                  disabled={true}
                />
                <button
                  className={
                    copyText === secretKeyCopy
                      ? "copyIconBtn tooltip2 active"
                      : "copyIconBtn tooltip2"
                  }
                  onClick={() => CopyContactAddress(secretKeyCopy)}
                >
                  <i
                    className={
                      copyText === secretKeyCopy
                        ? "fa fa-clone active"
                        : "fa fa-clone"
                    }
                    aria-hidden="true"
                  />
                  <div className="tooltiptext2">
                    <p>{t("Copied")}</p>
                  </div>
                </button>
              </div>
              <div className="modalInput label-color flexWrap">
                <TextField
                  label={t("Public_Key")}
                  value={publicKeyCopy}
                  disabled={true}
                />
                <button
                  className={
                    copyText === publicKeyCopy
                      ? "copyIconBtn tooltip2 active"
                      : "copyIconBtn tooltip2"
                  }
                  onClick={() => {
                    CopyContactAddress(publicKeyCopy);
                  }}
                >
                  <i
                    className={
                      copyText === publicKeyCopy
                        ? "fa fa-clone active"
                        : "fa fa-clone"
                    }
                    aria-hidden="true"
                  />
                  <div className="tooltiptext2">
                    <p>{t("Copied")}</p>
                  </div>
                </button>
              </div>
              <div className="wallet-note">
                <Checkbox onChange={copyConfirmHandler}>
                  {t("Wallet_Note")}
                </Checkbox>
              </div>
              <div className="modal_footer">
                <button
                  disabled={!confirmCopy}
                  className="btn btn-default senderBtn"
                  onClick={handleCloseKeysModal}
                >
                  {t("Ok")}
                </button>
              </div>
            </div>
          </Fade>
        </Modal>
      </div>
    </>
  );
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(withTranslation()(NewAccount))
);
